import { getRequestData } from "../../Utility/apiHelper";
import * as actionType from "./type";

export const requestGetTextfieldDetails = (entity) => async (dispatch) => {
  try {
    dispatch({
      type: actionType.REQUEST_LEAD_TEXTFIELD_DETAILS,
    });

    const url = `${process.env.REACT_APP_BASE_URL}entity-customizations/${entity}`;
    const responsedata = await getRequestData(url, false);

    if (responsedata?.status === 200) {
      dispatch({
        type: actionType.RECEIVED_LEAD_TEXTFIELD_DETAILS,
        payload: responsedata?.data || {},
      });
    } else {
      dispatch({
        type: actionType.RECEIVED_ERROR,
      });
    }
  } catch (error) {
    dispatch({
      type: actionType.RECEIVED_ERROR,
    });
  }
};


export const requestGetAllTextfieldDetails = (entity) => async (dispatch) => {
  try {
    dispatch({
      type: actionType.REQUEST_ALL_TEXTFIELD_DETAILS,
    });

    const url = `${process.env.REACT_APP_BASE_URL}entity-customizations`;
    const responsedata = await getRequestData(url, false);

    if (responsedata?.status === 200) {
      dispatch({
        type: actionType.RECEIVED_ALL_TEXTFIELD_DETAILS,
        payload: responsedata?.data || {},
      });
    } else {
      dispatch({
        type: actionType.RECEIVED_ERROR,
      });
    }
  } catch (error) {
    dispatch({
      type: actionType.RECEIVED_ERROR,
    });
  }
};